import styled from 'styled-components'
import DatePicker from 'react-datepicker'
import { colors } from '../../../ui-kit'

const DatePickerWrapper = styled(({ className, ...props }) => (
  <DatePicker {...props} wrapperClassName={className} />
))`
  margin-right: 12px;
  height: 100%;

  .react-datepicker__input-container {
    height: 100%;
  }
  .react-datepicker__input-container input {
    height: 100%;
    border: 1px solid ${colors.appPaleLilac};
    border-radius: 5px;
    padding-left: 12px;
    width: 100%;
    height: 35px;
  }
`

const Calendar = styled.div`
  border-radius: 5px;
  box-shadow: 0 6px 12px rgba(27, 37, 86, 0.16);
  overflow: hidden;
`

const Popper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
`

const DatePickerWrapperComponent = props => (
  <DatePickerWrapper
    popperContainer={Popper}
    calendarContainer={Calendar}
    {...props}
  />
)

export default DatePickerWrapperComponent
